export const msi = {
    agencyCode: '790',
    name: 'DIR Shared Technology Services',
    shortName: 'MSI',
    slug: 'msi',
  };
  